import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, Download } from "lucide-react";
import { api, fdate, downloadPdf } from "@/lib/api";
import { PageHeader, TableWrap, Th, Td, Empty, NSelect } from "@/components/common";
import { ServiceOptions } from "@/pages/QuoteForm";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function Archives() {
  const [items, setItems] = useState([]);
  const [services, setServices] = useState([]);
  const [q, setQ] = useState("");
  const [sid, setSid] = useState("");
  const [year, setYear] = useState("");
  const navigate = useNavigate();

  useEffect(() => { api.get("/services").then((r) => setServices(r.data)); }, []);
  useEffect(() => {
    const t = setTimeout(() => {
      api.get("/archives", { params: { ...(q && { q }), ...(sid && { service_id: sid }), ...(year && { year }) } }).then((r) => setItems(r.data));
    }, 250);
    return () => clearTimeout(t);
  }, [q, sid, year]);

  const years = Array.from({ length: 6 }, (_, i) => String(new Date().getFullYear() - i));
  const sname = (id) => services.find((s) => s.id === id)?.name || "—";

  return (
    <div>
      <PageHeader kicker="Direction" title="Archives des rapports" />
      <div className="mb-5 grid gap-3 sm:grid-cols-[1fr_260px_140px]">
        <div className="relative">
          <Search className="absolute left-3 top-2.5 h-4 w-4 text-slate-400" />
          <Input className="pl-9" placeholder="Rechercher : intitulé, client, site, n°…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="archives-search-input" />
        </div>
        <NSelect value={sid} onChange={setSid} testId="archives-service-filter"><option value="">Tous les services</option><ServiceOptions services={services} /></NSelect>
        <NSelect value={year} onChange={setYear} testId="archives-year-filter"><option value="">Toutes années</option>{years.map((y) => <option key={y}>{y}</option>)}</NSelect>
      </div>
      {items.length ? (
        <TableWrap>
          <thead><tr><Th>N°</Th><Th>Intitulé</Th><Th>Client / site</Th><Th>Service</Th><Th>Archivé le</Th><Th className="text-right">Rapport</Th></tr></thead>
          <tbody>
            {items.map((i) => (
              <tr key={i.id} className="cursor-pointer hover:bg-slate-50" onClick={() => navigate(`/interventions/${i.id}`)} data-testid={`archive-row-${i.number}`}>
                <Td className="font-mono text-xs">{i.number}</Td>
                <Td className="font-medium">{i.title}</Td>
                <Td>{i.client_name}<span className="block text-xs text-slate-500">{i.site}</span></Td>
                <Td className="text-xs">{sname(i.service_id)}</Td>
                <Td>{fdate(i.archived_at)}</Td>
                <Td className="text-right">
                  <Button size="sm" variant="outline" data-testid={`archive-pdf-${i.number}`} onClick={(e) => { e.stopPropagation(); downloadPdf(`/interventions/${i.id}/report.pdf`, `Rapport-${i.number}.pdf`); }}>
                    <Download className="h-3.5 w-3.5" />
                  </Button>
                </Td>
              </tr>
            ))}
          </tbody>
        </TableWrap>
      ) : <Empty testId="archives-empty" text="Aucun rapport archivé pour ces critères." />}
    </div>
  );
}
